class StickyForm extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._stickyContainer = null;
      this.priceDisplay = null;
      this.variantInput = null;
      this.planInput = null;
      this.freqButtons = null;
      this.selectedPlanId = null;
      this.qtyDisplay = null;
      this._onPackChange = this._onPackChange.bind(this);
    }
  
    connectedCallback() {
      this._stickyContainer = this.querySelector('.sticky-form__container');
      this.priceDisplay = this.querySelector('.sticky-price');
      this.variantInput = this.querySelector('#sticky-variant');
      this.qtyDisplay = this.querySelector('.sf-qty-selected');
  
      this.planInput = document.createElement('input');
      this.planInput.type = 'hidden';
      this.planInput.name = 'selling_plan';
      this.appendChild(this.planInput);
  
      this._bindVariantButtons();
      this._bindFrequencyButtons();
      this._bindFormSubmit();
      this._bindToggleOptions();
      this._updatePrice();
      this._setInitialVisibility();
      this._initObserver();

      document.addEventListener('monka:pack-change', this._onPackChange);

    }
  
    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      document.removeEventListener('monka:pack-change', this._onPackChange);
    }
  
    _bindVariantButtons() {
      this.querySelectorAll('.variant-buttons.quantities').forEach(group => {
        group.addEventListener('click', event => {
          const btn = event.target.closest('button.variant-button');
          if (!btn || btn.disabled) return;
          group.querySelectorAll('button.variant-button.active').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          this.variantInput.value = btn.dataset.variantId;
          this._updatePrice();
        });
      });
    }
  
    _bindFrequencyButtons() {
      this.freqButtons = this.querySelectorAll('.variant-buttons.frequency button.variant-button');
      this.freqButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.freqButtons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          this.selectedPlanId = btn.dataset.sellingPlanId || null;
          this.planInput.value = this.selectedPlanId || '';
          this._updatePrice();
        });
      });
      if (this.freqButtons && this.freqButtons.length) {
        const first = this.freqButtons[0];
        first.classList.add('active');
        this.selectedPlanId = first.dataset.sellingPlanId || null;
        this.planInput.value = this.selectedPlanId || '';
      }
    }
  
    _bindFormSubmit() {
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', event => {
        event.preventDefault();
        this._directCheckout();
      });
    }
  
    _bindToggleOptions() {
      const toggleBtn = this.querySelector('.toggle-options');
      if (!toggleBtn) return;
      const toggleText = toggleBtn.querySelector('.toggle-text');
      toggleBtn.addEventListener('click', () => {
        const isOpen = this.classList.toggle('open');
        toggleText.textContent = isOpen ? 'Fermer les options' : 'Ouvrir les options';
      });
    }
  
    _updatePrice() {
      const activeQty = this.querySelector('.variant-buttons.quantities button.variant-button.active');
      if (!activeQty || !this.priceDisplay) return;
      const priceStr = activeQty.dataset.price.replace(/[\s ]/g, '');
      const baseCents = Math.round(parseFloat(priceStr.replace(',', '.').replace(/[^0-9\.]/g, '')) * 100);
      let finalCents = baseCents;
  
      const freqActive = this.querySelector('.variant-buttons.frequency button.variant-button.active');
      if (freqActive && freqActive.dataset.discount) {
        const discountPerc = parseFloat(freqActive.dataset.discount);
        if (!isNaN(discountPerc)) {
          finalCents = Math.round(baseCents * (100 - discountPerc) / 100);
        }
      }
  
      this.priceDisplay.textContent = (finalCents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }
  
   async _directCheckout() {
      const vid = parseInt(this.variantInput?.value, 10);
      if (isNaN(vid)) return;

      const payload = {
        items: [{
          id: vid,
          quantity: 1,
          ...(this.selectedPlanId ? { selling_plan: parseInt(this.selectedPlanId, 10) } : {}),
        }]
      };

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!r.ok) throw new Error('Add to cart failed');
        await this._refreshSectionsAndOpenDrawer();
      } catch (e) {
        alert('Une erreur est survenue');
      }
    }

  
    _getTargetSection() {
      return document.querySelector('section[data-section-type="w-main-product"], section[data-section-type="main-product"]');
    }
  
    _isInViewWithMargins(el, marginTop, marginBottom) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const topLimit = 0 - marginTop;
      const bottomLimit = vh + marginBottom;
      return rect.bottom > topLimit && rect.top < bottomLimit;
    }
  
    _setInitialVisibility() {
      if (!this._stickyContainer) return;
      const target = this._getTargetSection();
      if (!target) {
        this._stickyContainer.classList.add('is-sticky');
        this._stickyContainer.classList.remove('is-exiting');
        return;
      }
      const inView = this._isInViewWithMargins(target, 100, 100);
      if (inView) {
        this._stickyContainer.classList.remove('is-sticky');
        this._stickyContainer.classList.add('is-exiting');
      } else {
        this._stickyContainer.classList.add('is-sticky');
        this._stickyContainer.classList.remove('is-exiting');
      }
    }
  
    _initObserver() {
      const target = this._getTargetSection();
      if (!target || !this._stickyContainer) return;
      this._observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._stickyContainer.classList.remove('is-sticky');
            this._stickyContainer.classList.add('is-exiting');
          } else {
            this._stickyContainer.classList.add('is-sticky');
            this._stickyContainer.classList.remove('is-exiting');
          }
        });
      }, { rootMargin: '-100px 0px -100px 0px', threshold: 0 });
      this._observer.observe(target);
    }

    _onPackChange(e) {
        const detail = e?.detail || {};
        const { variantId, sizeText, price } = detail;
      
        if (this.variantInput && variantId) {
          this.variantInput.value = variantId;
        }
      
        const qtyEl = this.qtyDisplay || this.querySelector('.sf-qty-selected');
        if (qtyEl && typeof sizeText === 'string') {
          this.qtyDisplay = qtyEl;
          qtyEl.textContent = sizeText;
        }
      
        if (this.priceDisplay && typeof price === 'string') {
          this.priceDisplay.textContent = price;
        } else {
          this._updatePrice();
        }
      }

      _openDrawerNow() {
        const d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { d.open(); return; }
        const t = document.querySelector('[data-cart-trigger], [data-drawer-toggle="cart"], button[aria-controls="CartDrawer"], .header__icon--cart');
        if (t) { t.click(); }
      }

      async _refreshSectionsAndOpenDrawer() {
        const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } });
        const json = await res.json();
        const wrap = document.createElement('div');

        if (json['cart-icon-bubble']) {
          const bubbleTarget = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
          wrap.innerHTML = json['cart-icon-bubble'];
          const bubbleNew = wrap.firstElementChild;
          if (bubbleTarget && bubbleNew) bubbleTarget.replaceWith(bubbleNew);
          wrap.innerHTML = '';
        }
        if (json['cart-drawer']) {
          const oldDrawer = document.querySelector('cart-drawer');
          wrap.innerHTML = json['cart-drawer'];
          const newDrawer = wrap.querySelector('cart-drawer');
          if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer);
          wrap.innerHTML = '';
        }
        requestAnimationFrame(()=> this._openDrawerNow());
      }

      

  }
  
  customElements.define('sticky-form', StickyForm);
  